<template>
  <v-app>
    <v-container class="py-0 px-4" justify-center>
      <!-- title row -->
      <v-layout row wrap>
        <v-flex xs12 class="text-xs-center">
          <p
            class="font-weight-bold"
            style="font-size: 40px !important; margin-bottom: 10px"
          >Our Mobile Application Services</p>
          <p
            class="subheading font-weight-light grey--text"
            style="max-width: 600px; margin: auto; margin-bottom: 70px"
          >Create a better, faster, and more collaborative mobile application for your business with real-time data management for an instantaneous workflow.</p>
        </v-flex>
      </v-layout>
      <!-- 1st row -->
      <v-layout class="pulseAnimationHover" row wrap align-center style="border: 1px solid #dbdee5; margin-bottom: 20px">
        <v-flex xs12 md7>
          <div class="px-5 pb-0 pt-3">
            <h2
              class="font-weight-bold"
              style="font-size: 28px !important"
            >Cross-Platform Application</h2>
            <div style="border: 2px solid #768ede; max-width: 100px; margin: 10px 0 20px 0"></div>
            <p
              style="font-size: 15px !important; color: #6d7783"
            >Thanks to cross-platform development, many organisation are now capable of controlling the cost of their operation since the need for development for multiple respective environments is substituted for a more adaptable environment. Hence, shortens the time needed for development as well as operation cost without affecting uniformity.</p>
          </div>
        </v-flex>
        <v-flex xs12 md5>
          <div style="height: 100%; width: 100%; text-align: center;">
            <img
              style="max-height: 100%; max-width: 100%; padding: 10%"
              src="/img/App-Avatar-1.svg"
              alt="App-Avatar-1.svg"
            >
          </div>
        </v-flex>
      </v-layout>
      <!-- 2nd row -->
      <v-layout class="pulseAnimationHover" row wrap align-center style="border: 1px solid #dbdee5; margin-bottom: 20px">
        <v-flex xs12 md5>
          <div style="height: 70%; width: 100%; text-align: center;">
            <img
              style="max-height: 100%; max-width: 100%; padding: 12%"
              src="/img/App-Avatar-2.svg"
              alt="App-Avatar-2.svg"
            >
          </div>
        </v-flex>
        <v-flex xs12 md7>
          <div class="px-5 pb-4 mb-1">
            <h2 class="font-weight-bold" style="font-size: 28px !important">Native Application</h2>
            <div style="border: 2px solid #768ede; max-width: 100px; margin: 10px 0 20px 0"></div>
            <p
              style="font-size: 15px !important; color: #6d7783"
            >As businesses grow, the need for optimisation becomes pivotal. Optimisation helps demonstrate a high level of flawless user experience. With a native development environment, a more responsive and faster application is assured compared to cross-development. It promotes efficiency within your daily operations especially with an application that is both highly interactive and intuitive.</p>
          </div>
        </v-flex>
      </v-layout>
      <!-- 3rd row -->
      <v-layout class="pulseAnimationHover" row wrap align-center style="border: 1px solid #dbdee5; margin-bottom: 20px;">
        <v-flex xs12 md7>
          <div class="px-5 pb-0 pt-3">
            <h2
              class="font-weight-bold"
              style="font-size: 28px !important"
            >App Content Management System</h2>
            <div style="border: 2px solid #768ede; max-width: 100px; margin: 10px 0 20px 0"></div>
            <p
              style="font-size: 15px !important; color: #6d7783"
            >With a content management system, users are able to manage the operations of their businesses without the need for outsourcing or any technical knowledge. Furthermore, in a mobile application form, users have the ease of maintaining their application anywhere and at any time.</p>
          </div>
        </v-flex>
        <v-flex xs12 md5>
          <div style="height: 70%; width: 100%; text-align: center;">
            <img
              style="max-height: 100%; max-width: 100%; padding: 13%"
              src="/img/App-Avatar-3.svg"
              alt="App-Avatar-3.svg"
            >
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- Website Capabilitiy -->
    <v-container class="py-0 px-4" justify-center style="margin-top: 100px">
      <v-layout row wrap align-center>
        <!-- 1st row -->
        <v-flex xs12 md6>
          <div>
            <p
              class="font-weight-bold"
              style="font-size: 32px !important;"
            >Our Mobile Application Capabilities</p>
            <div style="border: 2px solid #768ede; max-width: 100px; margin: 10px 0 20px 0"></div>
            <p
              class="subheading font-weight-light grey--text"
              style="margin-bottom: 40px"
            >What we can provide for you.</p>

            <div class="slider">
              <input
                type="radio"
                name="slider"
                title="slide1"
                checked="checked"
                class="slider__nav"
              >
              <input type="radio" name="slider" title="slide2" class="slider__nav">
              <div class="slider__inner">
                <div class="slider__contents">
                  <v-container class="pa-0" justify-center>
                    <v-layout justify-center row wrap>
                      <v-flex xs12 sm7 md6 class="capabilities-flex">
                        <v-icon color="blue">mdi-language-css3</v-icon>
                        <h3 class="font-weight-bold">UI/UX Design</h3>
                        <p>Learn who is your targeted audience and design it according to their experience in mind.</p>
                      </v-flex>
                      <v-flex xs12 sm7 md6 class="capabilities-flex">
                        <v-icon color="blue">mdi-clock-fast</v-icon>
                        <h3 class="font-weight-bold">Responsive Web Application Development</h3>
                        <p>Investigation on newest technology is conducted to ensure your mobile application is ready for the future.</p>
                      </v-flex>
                      <v-flex xs12 sm7 md6 class="capabilities-flex">
                        <v-icon color="blue">mdi-cellphone</v-icon>
                        <h3 class="font-weight-bold">Mobile Responsive</h3>
                        <p>The mobile application design will fit all mobile screen sizes providing the best user experience.</p>
                      </v-flex>
                      <v-flex xs12 sm7 md6 class="capabilities-flex">
                        <v-icon color="blue">mdi-speedometer</v-icon>
                        <h3 class="font-weight-bold">Performance Optimised</h3>
                        <p>The mobile application is built with high performance in mind to prevent your customers from getting frustrated.</p>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </div>
                <div class="slider__contents">
                  <v-container class="pa-0" justify-center>
                    <v-layout justify-center row wrap>
                      <v-flex xs12 sm7 md6 class="capabilities-flex">
                        <v-icon color="blue">mdi-security</v-icon>
                        <h3 class="font-weight-bold">Secure and Safe</h3>
                        <p>Security is the only real threat. Hence all applications will undergo testing to eliminate the existence of potential security risk.</p>
                      </v-flex>
                      <v-flex xs12 sm7 md6 class="capabilities-flex">
                        <v-icon color="blue">mdi-anchor</v-icon>
                        <h3 class="font-weight-bold">Native Design</h3>
                        <p>The design and feel of the mobile application will follow the design principle of either Android and iOS devices.</p>
                      </v-flex>
                      <v-flex xs12 sm7 md6 class="capabilities-flex">
                        <v-icon color="blue">mdi-chart-pie</v-icon>
                        <h3 class="font-weight-bold">Content Management System</h3>
                        <p>Cotenet Management System will be based on your mobile application to manage and analyse data with ease.</p>
                      </v-flex>
                      <v-flex xs12 sm7 md6 class="capabilities-flex">
                        <v-icon color="blue">mdi-bug</v-icon>
                        <h3 class="font-weight-bold">Robust Testing</h3>
                        <p>Numerous testing will be done to ensure your mobile application is ready for delivery under all circumstances.</p>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </div>
              </div>
            </div>
          </div>
        </v-flex>
        <!-- 2nd row -->
        <v-flex xs12 md6>
          <div class="wavy-box">
            <div class="wave -one"></div>
            <div class="wave -two"></div>
            <div class="wave -three"></div>
            <div class="wavy-box hidden-sm-and-down">
              <img
                style="max-width: 365px; height: auto; z-index: 11;"
                src="/img/Application-Mockup.png"
                alt
              >
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- Navigate to Portfolio -->
    <v-container style="margin-top: 100px; border: 1px solid #dbdee5;">
      <v-layout row wrap align-center justify-center>
        <v-flex xs12 md6 class="text-xs-center" style="padding: 70px 0;">
          <p
            class="font-weight-black"
            style="font-size: 3.3125rem !important;
    line-height: 1.15em !important; padding-bottom: 20px !important"
          >Still Not Conviced?</p>
          <p
            class="font-weight-thin m-message"
            style="font-size: 24px !important; padding-bottom: 20px !important"
          >
            We'll make you a
            <del class="a-modification -lineThrough">disbeliver</del>
            <ins class="a-modification -underlined">believer</ins>.
          </p>
          <button @click="toPage('Portfolio')" class="btn-portfolio btn-reverse btn-arrow">
            <span>
              See Our Portfolio
              <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 36.1 25.8"
                enable-background="new 0 0 36.1 25.8"
                xml:space="preserve"
              >
                <g>
                  <line
                    fill="none"
                    stroke="#FFFFFF"
                    stroke-width="3"
                    stroke-miterlimit="10"
                    x1="0"
                    y1="12.9"
                    x2="34"
                    y2="12.9"
                  ></line>
                  <polyline
                    fill="none"
                    stroke="#FFFFFF"
                    stroke-width="3"
                    stroke-miterlimit="10"
                    points="22.2,1.1 34,12.9 22.2,24.7   "
                  ></polyline>
                </g>
              </svg>
            </span>
          </button>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
export default {
  metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Everowl Technologies',
      // all titles will be injected into this template
      titleTemplate: 'App Development Malaysia | Mobile Application | %s',
      meta: [
        { charset: 'utf-8' },
        { name: 'description', content: 'Get started and build your mobile application now! We support both natively and cross-development, ensuring top-notch quality development!'},
        { name: 'keywords', content: 'app development malaysia, app development kuala lumpur, custom application development, mobile application development' }
      ]
  },

  data: () => ({}),
  methods: {
    navigateTo(route) {
      this.$router.push(route);
    },
    toPage(name) {
      this.$router.push({ name: name });
    }
  }
};
</script>

<style>

</style>

